import { useState, useCallback, useEffect } from "react";

const useActiveIcon = (initialIcon = null) => {
  const [activeIcon, setActiveIcon] = useState(initialIcon);

  const handleActivateIcon = useCallback((iconName) => {
    setActiveIcon(iconName);
  }, []);

  const handleDeactivateIcon = useCallback(() => {
    setActiveIcon(null);
  }, []);

  const handleToggleIcon = useCallback((iconName) => {
    setActiveIcon((prev) => (prev === iconName ? null : iconName));
  }, []);

  useEffect(() => {
    const handleMouseDown = () => handleDeactivateIcon();
    window.addEventListener("mousedown", handleMouseDown);
    return () => {
      window.removeEventListener("mousedown", handleMouseDown);
    };
  }, [handleDeactivateIcon]);

  return {
    activeIcon,
    handleActivateIcon,
    handleDeactivateIcon,
    handleToggleIcon, // This was defined but not returned in your original code
  };
};

export default useActiveIcon;
